import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaGlobe,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const B2BEcommerceSolutionsInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="B2B E-commerce Solutions in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Empower Your Business</Subheading>}
        heading={
          <Heading>
            B2B <span tw="text-primary-500">E-commerce Solutions</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver cutting-edge B2B e-commerce solutions
            in **DIFC**, Dubai’s global financial hub. Our platforms streamline
            transactions, enhance efficiency, and drive growth for businesses in
            the UAE and beyond.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1554774853-aae0a22c8aa4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Explore Solutions"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Tailored B2B Solutions in DIFC"
        description="Unlock the potential of your business with our expert e-commerce platforms."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Seamless Integration",
            description:
              "Connect with ERP, CRM, and supply chain systems effortlessly.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Bulk Transactions",
            description: "Optimized for high-volume orders and custom pricing.",
          },
          {
            icon: <FaGlobe color="#ff5464" size={40} />,
            title: "Global Scalability",
            description:
              "Expand with multi-currency and multi-language support.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Deployment",
            description: "Launch robust platforms quickly in DIFC’s ecosystem.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Access",
            description:
              "Responsive designs for on-the-go business management.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success for DIFC-based enterprises.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our B2B E-commerce Process"
        description={
          <Description>
            We craft B2B e-commerce platforms with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your business needs and goals.</li>
              <li>Design: Create intuitive, client-focused interfaces.</li>
              <li>Development: Build secure, scalable platforms.</li>
              <li>Integration: Sync with your existing systems.</li>
              <li>Testing: Ensure reliability and performance.</li>
              <li>Launch & Support: Go live with ongoing optimization.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1579389083078-4e7018379f7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1573164713712-d3f17d3f56cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="B2B Wins in DIFC"
        description="Our solutions transform business operations."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Efficiency Boost",
            description: "Streamlined procurement for a DIFC wholesaler.",
          },
          {
            icon: <FaGlobe color="#ff5464" size={40} />,
            title: "Market Expansion",
            description: "Enabled global trade for a logistics firm.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval from DIFC businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Grow?</Subheading>}
        heading="B2B E-commerce Excellence in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for advanced B2B e-commerce solutions in
            DIFC. Build a powerful platform that drives your business
            forward—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1550305080-4e029753abcf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
